import { useUser } from '../../contexts/UserContext';
import { FullPageSpinner } from '../../components/common/FullPageSpinner';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { userHasAccessToView } from '../../utils/userHasAccessToView';
import { useConnectWebsocket } from '../../api/WebSocketService/useConnectWebsocket';
import { useWorkerView } from '../../contexts/WorkersContext';
import { getUserPushNotificationsResponse } from '../../api/PushNotificationSubscriptionService/getUserPushNotificationsResponse';

export const drawerCssProps = {
  openWidth: 240,
  closedWidth: 60,
};

export const Dashboard = () => {
  const { isAuthenticated } = useAuth0();
  const location = useLocation();
  const { action: connectWebsocket } = useConnectWebsocket();
  const { user } = useUser();
  const { getPushNotificationsResponse, data: usersPushNotificationsResponse } =
    getUserPushNotificationsResponse();
  const { setPushNotifications, setUserHasUnreadPushNotifications } = useWorkerView();

  const userIsLoaded = user !== null;

  useEffect(() => {
    // Waits for the user, since the backend answers 404 until the organization is set up.
    if (userIsLoaded) {
      connectWebsocket();
    }
  }, [userIsLoaded]);

  useEffect(() => {
    // only get push notifications if user is on workers pages
    if (isAuthenticated && location.pathname.includes('employee')) {
      getPushNotificationsResponse();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (usersPushNotificationsResponse) {
      setPushNotifications(usersPushNotificationsResponse.pushNotifications);
      setUserHasUnreadPushNotifications(usersPushNotificationsResponse.userHasUnreadNotifications);
    }
  }, [usersPushNotificationsResponse]);

  if (!user) {
    return <FullPageSpinner />;
  }

  if (!userHasAccessToView(location.pathname, user)) {
    return <div>Du saknar access för att kunna se denna vy.</div>;
  }

  // check access level and render page if the user has access
  return (
    <div data-testid="outlet">
      <Outlet />
    </div>
  );
};
